<template>
  <div :endpoint='submitEndpoint'>
    <div class="top-buttons" v-if="!loading && cards && (cards.length > 1)">
      <ed-button class="btn btn-actionbar primary"
                 @click="showApproveAll">
        Approve All
      </ed-button>
      <ed-button class="btn btn-actionbar"
                 @click="showRejectAll">
        {{rejectText}} All
      </ed-button>
    </div>

    <div class="wrapper">
      <div class="scroller" v-if='hasData'>
        <div>
          <card v-for="(card, i) in cards"
                :key="i"
                :id="`card-${i}`"
                :useMeetingRequestor="useMeetingRequestor"
                :meetingRequesterName="meetingRequesterName"
                :rejectText="rejectText"
                :card="card"
                :programLabel="programLabel"
                :divisionLabel="divisionLabel"
                :lastEntry="i === cards.length - 1"
                @onApprove="showApprove(card)"
                @onReject="showReject(card)" />
        </div>
      </div>
            <div class="empty-holder" v-if='this.loading'>
              <span class ="approval-loading" /> Loading approval queue ...
      </div>
     <div class="empty-holder" v-if='!this.loading && !hasData'>
        <i class="fal fa-check-circle"/> 
        <span>
        <p class="bold">No Items in Queue</p>
        <p class="light">No items are ready for review</p>
        </span>
      </div>
    </div>

    <approveDialog :showModal="showApproveDialog"
                   :list="dialogList"
                   :programLabel="programLabel"
                   :divisionLabel="divisionLabel"
                   @approve="doApprove"
                   :submitEndpoint="submitEndpoint"
                   @close="() => { showApproveDialog = false }"
    />

    <rejectDialog :showModal="showRejectDialog"
                  :list="dialogList"
                  :rejectText="rejectText"
                  :programLabel="programLabel"
                  :divisionLabel="divisionLabel"
                  @reject="doReject"
                  :submitEndpoint="submitEndpoint"
                  @close="() => { showRejectDialog = false }"
    />
  </div>
</template>

<script>
  import card from './card'
  import approveDialog from './approve-dialog'
  import rejectDialog from './reject-dialog'
  import { initScrollbar } from '../../helpers/scrollbarHelper.js'
  import { EventBus } from '@/event-bus'
  import user from '@/core/user'
  export default {
    alias: 'approval-needed-wdg-cmp',

    props: { widget: Object },

    computed: {
      hasData() {
        return ((this.cards !== null) && (this.cards.length > 0))
      }
    },

    data() {
      return {
        useMeetingRequestor: false,
        meetingRequesterName: null,
        originalLabel: null,
        cards: [],
        showRejectDialog: false,
        showApproveDialog: false,
        dialogList: [],
        rejectText: null,
        loading: false,
        companySettings: {},
        programLabel: 'Program',
        divisionLabel: 'Division',
        submitEndpoint: null
      }
    },

    created() {
      if (!this.widget.originalLabel) {
        this.widget.originalLabel = this.widget.label
      }

      this.originalLabel = this.widget.originalLabel
      this.companySettings = user.getCompanySettings()
      this.programLabel = this.companySettings.ProgramLabel ? this.companySettings.ProgramLabel : 'Program'
      this.divisionLabel = this.companySettings.DivsionLabel ? this.companySettings.DivisionLabel : 'Division'
      this.approveUrl = this.widget.endPoint.replace(/GetApprovalNeededList/, 'Approve')
      this.rejectUrl = this.widget.endPoint.replace(/GetApprovalNeededList/, 'Reject')

      this.reload()
    },

    methods: {
      reload() {
        this.loading = true
        this.showApproveDialog = false
        this.showRejectDialog = false
        this.api.get(this.widget.endPoint, {})
          .then(r => {
            this.useMeetingRequestor = r.data.useMeetingRequestor
            this.meetingRequesterName = r.data.meetingRequesterName
            this.rejectText = 'Decline'
            this.cards = r.data.items
            this.widget.label = (this.cards && this.cards.length)
              ? (this.originalLabel + ' (' + this.cards.length + ')')
              : this.originalLabel
            if (this.hasData) {
              this.$nextTick(() => {
                EventBus.$emit('updateWidgetHeightSimple', {
                  wId: this.widget.id,
                  height: this.$el.clientHeight + (this.cards.length === 1 ? 20 : 0)
                })
                if (this.cards.length >= 5) initScrollbar(this, '.scroller')
              })
            }

            const cardId = this.$route.query.cardId
            const isApprove = this.$route.query.IsApproveCardFromEmail
            const isReject = this.$route.query.IsRejectCardFromEmail
            if (cardId && isApprove) {
              const card = this.cards.find(c => c.Id === cardId)
              this.showApprove(card)
            }
            if (cardId && isReject) {
              const card = this.cards.find(c => c.Id === cardId)
              this.showReject(card)
            }

            const cardFundsId = this.$route.query.cardFundsId
            const isApproveCardFunds = this.$route.query.IsApproveCardFundsFromEmail
            const isRejectCardFunds = this.$route.query.IsRejectCardFundsFromEmail
            if (cardFundsId && isApproveCardFunds) {
              const card = this.cards.find(c => c.Id === cardFundsId)
              this.showApprove(card)
            }
            if (cardFundsId && isRejectCardFunds) {
              const card = this.cards.find(c => c.Id === cardFundsId)
              this.showReject(card)
            }

            const cardRefillId = this.$route.query.cardRefillId
            const isApproveCardRefill = this.$route.query.IsApproveCardRefillFromEmail
            const isRejectCardRefill = this.$route.query.IsRejectCardRefillFromEmail
            if (cardRefillId && isApproveCardRefill) {
              const card = this.cards.find(c => c.Id === cardRefillId)
              this.showApprove(card)
            }
            if (cardRefillId && isRejectCardRefill) {
              const card = this.cards.find(c => c.Id === cardRefillId)
              this.showReject(card)
            }
          })
          .finally(() => { this.loading = false })
      },

      showApproveAll() {
        this.dialogList = this.cards
        this.showApproveDialog = true
        this.scrollParentTopIfInIframe()
      },

      showRejectAll() {
        this.dialogList = this.cards
        this.showRejectDialog = true
        this.scrollParentTopIfInIframe()
      },

      showApprove(card) {
        this.dialogList = [card]
        this.showApproveDialog = true
        this.scrollParentTopIfInIframe()
      },

      showReject(card) {
        this.dialogList = [card]
        this.showRejectDialog = true
        this.scrollParentTopIfInIframe()
      },

      scrollParentTopIfInIframe() {
        if (window.self === window.top) return

        this.$nextTick(() => {
          try {
            const parentDoc = window.parent.document
            const overlayShell = parentDoc.querySelector('.stepin-layout-content')

            if (overlayShell) {
              if (overlayShell.scrollTo) {
                overlayShell.scrollTo({ top: 0, behavior: 'smooth' })
              } else {
                overlayShell.scrollTop = 0
              }
              return
            }

            // fallback: scroll main document
            const scroller =
              parentDoc.scrollingElement ||
              parentDoc.documentElement ||
              parentDoc.body

            if (scroller.scrollTo) {
              scroller.scrollTo({ top: 0, behavior: 'smooth' })
            } else {
              scroller.scrollTop = 0
            }
          } catch (e) {
            console.error('Could not scroll parent from iframe:', e)
          }
        })
      },

      getIdsList() { return this.dialogList.map((item) => item.Id) },

      doApprove(reason) {
        this.loading = true
        this.submitEndpoint = this.approveUrl
        // /ApprovalNeededWidget/Approve
        this.api.post(this.approveUrl, { list: this.getIdsList(), reason: reason })
          .then(r => { this.reload() })
          .finally(() => { this.loading = false })
      },

      doReject(reason, notifySupplier) {
        this.loading = true
        this.submitEndpoint = this.rejectUrl
        // /ApprovalNeededWidget/Reject
        this.api.post(this.rejectUrl, { list: this.getIdsList(), reason: reason, notifySupplier: notifySupplier })
          .then(r => { this.reload() })
          .finally(() => { this.loading = false })
      }
    },

    components: { card, approveDialog, rejectDialog }
  }

</script>

<style scoped lang="scss">
  .top-buttons {
    position: absolute;
    right: 60px;
    top: -1px;
    .btn.btn-actionbar.primary{
      &:hover {
        color: white;
        background:  #4a90e2;
      }
      color: white;
      background:  #4a90e2;
    }
  }

  .wrapper {
    min-height: 30px;
    height: auto;
    max-height: 700px;
  }

  .scroller {
    min-height: 30px;
    height: auto;
    max-height: 635px;
    position: relative;
    padding-right: 10px;
    overflow-y: hidden;
  }
  .approval-loading{
    margin-top: 25px;
    margin-left: 50px;
  }

 div.empty-holder {
    position: absolute;
    left: 160px;
    i.fal{
      font-size: 1.7rem;
      height: 50px;
      width: 50px;
      padding-top:12px;
      padding-left:1px;
      background-color:#f2f2f2;
      border-radius: 50%;
      display: inline-block;
      margin-right: 10px;
    }
    text-align: center;
    vertical-align: middle;
    margin-top: 0px;
    color: #9c9c9c;
    font-size: 0.96em;
    font-weight: 600;
    span{
      text-align: left;
      display: inline-block;
      p{
        line-height: 0.4rem;
        display:block;
        &.bold{
          font-weight: 650
        }
        &.light{
          font-size: 0.8rem;
          font-weight: 200;
        }
    }
  }}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/ApprovalNeeded/index.vue